<template>
  <v-app>
    <v-content>
      <div class="row" style="height: 100%; margin: 0 !important;">
        <div class="column" style="background-color:#2196F3;">
          <v-container fluid fill-height>
            <v-layout align-center justify-center>
              <img src="../assets/img/logo.svg" height="95" width="270">
            </v-layout>
          </v-container>
        </div>
        <div class="column" style="background-color:#fff;">
          <v-container fluid fill-height>
            <v-layout align-center justify-center>
              <v-card class="elevation-0" width="600">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="text-h5">
                      Enterprise Dashboard
                    </v-list-item-title>
                    <v-list-item-subtitle>New account registration</v-list-item-subtitle>
                    <v-list-item-title v-if="signed" class="text-h6 mt-5">
                      Sign up completed! Check your email for future instructions!
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-card-text v-if="!signed">
                  <template>
                    <v-stepper v-model="e1" flat>
                      <v-stepper-items>
                        <v-stepper-content step="1" class="mx-0 px-0 my-0 py-0">
                          <v-card>
                            <v-card-text class="mx-0 px-0">
                              <v-text-field v-model="accountName" label="Account name" type="text"></v-text-field>
                              <v-text-field v-model="accountEmail" label="Account main email" type="text"></v-text-field>
                            </v-card-text>
                            <v-card-actions class="mx-0 px-0">
                              <v-spacer></v-spacer>
                              <v-btn :disabled="accountName == '' || accountEmail == ''" color="primary" @click="e1 = 2" >Next</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="2" class="mx-0 px-0 my-0 py-0">
                          <v-card>
                            <v-card-text class="mx-0 px-0">
                              <v-text-field v-model="adminFirstName" label="Account admin first name" type="text"></v-text-field>
                              <v-text-field v-model="adminLastName" label="Account admin last name" type="text"></v-text-field>
                              <v-text-field v-model="adminEmail" label="Account admin email" type="text"></v-text-field>
                            </v-card-text>
                            <v-card-actions class="mx-0 px-0">
                              <v-spacer></v-spacer>
                              <v-btn :disabled="adminFirstName == '' || adminLastName == '' || adminEmail == ''" color="primary" @click="e1 = 3" >Next</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="3" class="mx-0 px-0 my-0 py-0">
                          <v-card>
                            <v-card-text class="mx-0 px-3">
                              <v-radio-group v-model="radioGroup" class="px-0 py-0 mx-0 my-0">
                                <v-card v-for="p in subscriptionPlans" :key="p.name" color="#fff" class="mb-3 elevation-5">
                                  <v-card-title class="text-h5">
                                    {{ p.name }}
                                  </v-card-title>
                                  <v-card-subtitle>In future here will be some description about current pricing plan</v-card-subtitle>
                                  <v-card-actions>
                                    <v-card-title class="text-h5 py-0">
                                      <b>{{ p.pricePerMonth }} € per month</b>&nbsp;&nbsp;&nbsp;<template class="font-weight-thin" v-if="p.annualPayDiscountPercentage != -1">Annual discount {{ p.annualPayDiscountPercentage }}%</template>
                                    </v-card-title>
                                  <v-spacer></v-spacer>
                                    <!-- <v-btn text>
                                      More info
                                    </v-btn> -->
                                    <v-radio :key="p.id" :value="p.id" ></v-radio>
                                  </v-card-actions>
                                </v-card>
                              </v-radio-group>
                            </v-card-text>
                            <v-card-actions class="mx-0 px-3">
                              <v-spacer></v-spacer>
                              <v-btn :disabled="loading" color="grey lighten-1" dark @click="e1 = 1" >Back</v-btn>
                              <v-btn :loading="loading" color="primary" @click="signUp()" >Sign up</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-stepper-content>
                      </v-stepper-items>
                    </v-stepper>
                  </template>
                </v-card-text>
              </v-card>
            </v-layout>
          </v-container>
        </div>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import { GET_PUBLIC_SUBSCRIPTION_PLANS, REGISTER_ORG } from '@/store/actions.type';
import uuidv4 from 'uuid/v4';

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      signed: false,
      radioGroup: 1,
      accountName: '',
      accountEmail: '',
      adminFirstName: '',
      adminLastName: '',
      adminEmail: '',
      subscriptionPlans: [],
      e1: 1,
      validateEmailRule: v => {
        // eslint-disable-next-line
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return (!!v && re.test(String(v).toLowerCase())) || 'Please enter a valid email address';
      },
    };
  },
  methods: {
    async signUp() {
      this.loading = true;
      const org = {
        id: uuidv4(),
        name: this.accountName,
        email: this.accountEmail,
        adminEmail: this.adminEmail,
        adminFirstName: this.adminFirstName,
        adminLastName: this.adminLastName,
        subscriptionPlanId: this.radioGroup,
        billingPeriod: 2
      }
      try {
        await this.$store.dispatch(REGISTER_ORG, org);
      } catch(err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error creating template. Please contact support@planetverify.com',
        });
      }
      this.loading = false;
      this.signed = true;
    },
    async getSubscriptionPlans() {
      const response = await this.$store.dispatch(GET_PUBLIC_SUBSCRIPTION_PLANS);
      this.subscriptionPlans = response.list;
      this.subscriptionPlans.sort((a, b) => a.pricePerMonth > b.pricePerMonth ? 1 : -1);
      this.radioGroup = this.subscriptionPlans[0].id;
    },
  },
  async mounted() {
    await this.getSubscriptionPlans();
  },
}
</script>

<style>
.forgot-link {
  text-decoration: none;
}

.forgot-link:hover {
  text-decoration: underline;
}

* {
  box-sizing: border-box;
}

.column {
  float: left;
  width: 50%;
  padding: 10px;
  min-height: 100%;
}

.row:after {
  content: "";
  display: table;
  clear: both;
}
</style>